export const projeler = {
    title: 'Projeler',
    titleEN: 'Projects',
    description: 'Hissenet platformu için geliştirilmiş özel ve yenilikçi projeler. Finans ve yatırım dünyasında kullanıcı deneyimini artıran çözümler.',
    descriptionEN: 'Special and innovative projects developed for the Hissenet platform. Solutions that enhance user experience in the world of finance and investment.',
    tabs: [
        {
            id: 1,
            title: 'Projeler',
            sliderPerView: 3,
            width: '100%',
            slides: [
                {
                    id: 1,
                    image: 'https://srv-cdn.onedio.com/store/2703bb9181c7d6e2c5901aed40ca556bfb466702ff0589a479f76891a3893205.png',
                    modal: 'image',
                    modalTitle: 'DeLonghi Takeover',
                    category: 'DeLonghi Takeover'
                },
                {
                    id: 2,
                    image: 'https://srv-cdn.onedio.com/store/3a7e162fcc026c14b0b3947ab832d130bde46f8f09d06a5ae1cecb621412742a.png',
                    modal: 'image',
                    modalTitle: 'Lenovo Masthead',
                    category: 'Lenovo Masthead'
                },
                {
                    id: 3,
                    image: 'https://srv-cdn.onedio.com/store/562f26a5f78a3b07b4e4cbc9df342b96b49cc6efae811b7533fe1aceba4f3538.png',
                    modal: 'image',
                    modalTitle: 'Kotex 300x250',
                    category: 'Kotex 300x250'
                },
                {
                    id: 4,
                    image: 'https://srv-cdn.onedio.com/store/917f5a2355bc989dcf3a1f8af0e93967526e2550e346998f6ff39922dad3fd85.png',
                    modal: 'image',
                    modalTitle: 'Turkcell Interstitial',
                    category: 'Turkcell Interstitial'
                },
                {
                    id: 5,
                    image: 'https://srv-cdn.onedio.com/store/f46d75f53f7ca5d648d6b093821e14b2a6b1563ca583737473ebbb85e2f6c06f.png',
                    modal: 'image',
                    modalTitle: 'YKB 300x600',
                    category: 'YKB 300x600'
                },
                {
                    id: 6,
                    image: 'https://srv-cdn.onedio.com/store/23ede9ffb8addd25d5e26147f27adf91e025a1f415ee7f32927a213bd7b8a2b5.png',
                    modal: 'image',
                    modalTitle: 'YKB 728x90',
                    category: 'YKB 728x90'
                }
            ]
        },

    ],
    egTabs: [
        {
            id: 1,
            title: 'Projects',
            sliderPerView: 3,
            width: '100%',
            slides: [
                {
                    id: 1,
                    image: 'https://srv-cdn.onedio.com/store/2703bb9181c7d6e2c5901aed40ca556bfb466702ff0589a479f76891a3893205.png',
                    modal: 'image',
                    modalTitle: 'DeLonghi Takeover',
                    category: 'DeLonghi Takeover'
                },
                {
                    id: 2,
                    image: 'https://srv-cdn.onedio.com/store/3a7e162fcc026c14b0b3947ab832d130bde46f8f09d06a5ae1cecb621412742a.png',
                    modal: 'image',
                    modalTitle: 'Lenovo Masthead',
                    category: 'Lenovo Masthead'
                },
                {
                    id: 3,
                    image: 'https://srv-cdn.onedio.com/store/562f26a5f78a3b07b4e4cbc9df342b96b49cc6efae811b7533fe1aceba4f3538.png',
                    modal: 'image',
                    modalTitle: 'Kotex 300x250',
                    category: 'Kotex 300x250'
                },
                {
                    id: 4,
                    image: 'https://srv-cdn.onedio.com/store/917f5a2355bc989dcf3a1f8af0e93967526e2550e346998f6ff39922dad3fd85.png',
                    modal: 'image',
                    modalTitle: 'Turkcell Interstitial',
                    category: 'Turkcell Interstitial'
                },
                {
                    id: 5,
                    image: 'https://srv-cdn.onedio.com/store/f46d75f53f7ca5d648d6b093821e14b2a6b1563ca583737473ebbb85e2f6c06f.png',
                    modal: 'image',
                    modalTitle: 'YKB 300x600',
                    category: 'YKB 300x600'
                },
                {
                    id: 6,
                    image: 'https://srv-cdn.onedio.com/store/23ede9ffb8addd25d5e26147f27adf91e025a1f415ee7f32927a213bd7b8a2b5.png',
                    modal: 'image',
                    modalTitle: 'YKB 728x90',
                    category: 'YKB 728x90'
                }
            ]
        },
    ]
} 